/**
 * 돌봄서비스 페이지 공통 스타일 컴포넌트
 * CareServiceInfo, CareContactInfo에서 공통으로 사용하는 스타일만 포함합니다.
 */

import styled from 'styled-components';
import listIcon from '../../assets/list.png';

/* 공통 컨테이너 */
export const Container = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  margin-top: 50px;
  padding-left: 38px;
  width: 100%;
  min-height: 500px;
  height: auto;
  font-family: 'koPubWorld DotumB';
  box-sizing: border-box;

  * {
    box-sizing: border-box;
  }

  @media (max-width: 767px) {
    padding-left: 5%;
    padding-right: 5%;
    margin-top: 20px;
  }
`;

/* 섹션 제목 */
export const SectionTitle = styled.h1`
  background: url(${listIcon}) left no-repeat;
  background-size: 20px 20px;
  color: #e5857c;
  font-size: 24px;
  padding-left: 30px;
  margin-bottom: 20px;
  font-family: 'Nanum Gothic Bold';
  box-sizing: border-box;
  max-width: 100%;

  @media (max-width: 767px) {
    font-size: 18px;
    background-size: 16px 16px;
    padding-left: 24px;
    margin-bottom: 12px;
  }
`;

/* 리스트 박스 */
export const ListBox = styled.div`
  margin-bottom: 40px;
  white-space: pre-wrap;
  box-sizing: border-box;
  max-width: 100%;

  p {
    font-size: 15px;
    font-weight: bold;
    display: flex;
    align-items: flex-start;
    line-height: 25px;
    word-break: keep-all;
    margin: 0 0 8px 0;

    > span {
      word-break: keep-all;
    }
  }

  @media (max-width: 767px) {
    margin-bottom: 25px;

    p {
      font-size: 13px;
      line-height: 20px;
    }
  }
`;

/* 불릿 포인트 */
export const BulletPoint = styled.span`
  font-size: 15px;
  font-weight: bold;
  color: #2679b2;
  margin-right: 8px;
  flex-shrink: 0;
  display: inline-block;
  width: 1em;
  text-align: center;

  @media (max-width: 767px) {
    font-size: 13px;
    margin-right: 6px;
  }
`;
